import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { purple, transition, getGlowBorder } from './glowUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Card', 'heroTheme'], (token: FullToken) => {
  const { componentCls, lineWidth } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      transition,
      borderRadius: 16,
      overflow: 'hidden',
      position: 'relative' as const,

      // hover 时浮起 + 紫色 glow 边框
      '&:before': getGlowBorder(lineWidth),
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: `0 8px 24px ${purple[600]}12, 0 2px 8px rgba(0,0,0,0.06)`,
        '&:before': { opacity: 1 },
      },

      // 卡片头部底边渐变线
      [`${componentCls}-head`]: {
        borderBottom: 'none',
        position: 'relative' as const,
        '&:after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 16,
          right: 16,
          height: 1,
          background: `linear-gradient(90deg, transparent, ${purple[500]}30, transparent)`,
        },
      },
    },
  }
})
